module.exports = __webpack_public_path__ + "static/w-abdb36e195d459a94063702cd183f7de.png";